// src/components/dashboard/StatsCard.jsx - Mobile-optimized stats card
import { motion } from "framer-motion";

export default function StatsCard({ 
  title, 
  value, 
  icon: Icon, 
  color = 'blue', 
  isLoading = false,
  compact = false // NEW: Compact mode for mobile
}) {
  const colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    orange: 'from-orange-500 to-orange-600',
    purple: 'from-purple-500 to-purple-600',
    red: 'from-red-500 to-red-600',
    yellow: 'from-yellow-500 to-yellow-600',
    pink: 'from-pink-500 to-pink-600',
    indigo: 'from-indigo-500 to-indigo-600'
  };

  const colorClass = colorClasses[color] || colorClasses.blue;

  if (isLoading) {
    return (
      <div className={`bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden ${compact ? 'p-3' : 'p-6'}`}>
        <div className="animate-pulse">
          <div className={`bg-slate-200 rounded ${compact ? 'h-3 w-16 mb-2' : 'h-4 w-20 mb-3'}`}></div>
          <div className={`bg-slate-200 rounded ${compact ? 'h-6 w-8' : 'h-8 w-12'}`}></div>
        </div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: compact ? 1.02 : 1.05 }}
      className={`bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden ${compact ? 'p-3' : 'p-6'}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className={`text-slate-600 font-medium ${compact ? 'text-xs mb-1' : 'text-sm mb-2'} ${compact ? 'leading-tight' : ''}`}>
            {compact && title.length > 12 ? `${title.substring(0, 12)}...` : title}
          </p>
          <p className={`font-bold text-slate-800 ${compact ? 'text-lg' : 'text-3xl'}`}>
            {typeof value === 'number' ? value.toLocaleString() : value}
          </p>
        </div>
        <div className={`bg-gradient-to-br ${colorClass} rounded-lg ${compact ? 'p-1.5' : 'p-3'} flex items-center justify-center`}>
          <Icon className={`text-white ${compact ? 'w-4 h-4' : 'w-6 h-6'}`} />
        </div>
      </div>
      
      {/* Optional: Add a subtle progress indicator for compact mode */}
      {compact && (
        <div className="mt-2 w-full bg-slate-100 rounded-full h-1">
          <div 
            className={`bg-gradient-to-r ${colorClass} h-1 rounded-full transition-all duration-300`}
            style={{ width: `${Math.min(100, (value / 10) * 100)}%` }}
          ></div>
        </div>
      )}
    </motion.div>
  );
}